import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";

// Organizer
import OrganizerDashboard from "./pages/organizer/OrganizerDashboard";
import Groups from "./pages/organizer/Groups";
import Progress from "./pages/organizer/Progress";
import Spinner from "./pages/organizer/Spinner";

// Member
import MemberDashboard from "./pages/member/MemberDashboard";
import MyGroups from "./pages/member/MyGroups";
import PaymentMenu from "./pages/member/PaymentMenu";
import Alerts from "./pages/member/Alerts";

export default function App() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      // ✅ Skip auto-login flow if just signed up
      if (localStorage.getItem("justSignedUp")) {
        setUser(null);
        setRole(null);
        setLoading(false);
        return;
      }

      if (currentUser) {
        try {
          const snap = await getDoc(doc(db, "users", currentUser.uid));
          if (snap.exists()) {
            setUser(currentUser);
            setRole(snap.data().role);
          } else {
            setUser(null);
            setRole(null);
          }
        } catch (err) {
          console.error("Error fetching user role:", err);
          setUser(null);
          setRole(null);
        }
      } else {
        setUser(null);
        setRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <p style={{ textAlign: "center", marginTop: "30px" }}>Loading...</p>;
  }

  return (
    <BrowserRouter>
      <Routes>
        {!user ? (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="*" element={<Navigate to="/signup" replace />} />
          </>
        ) : role ? (
          <>
            {role === "organizer" && (
              <>
                <Route path="/organizer/dashboard" element={<OrganizerDashboard />} />
                <Route path="/organizer/groups" element={<Groups />} />
                <Route path="/organizer/progress" element={<Progress />} />
                <Route path="/organizer/spinner" element={<Spinner />} />
              </>
            )}

            {role === "member" && (
              <>
                <Route path="/member/dashboard" element={<MemberDashboard />} />
                <Route path="/member/my-groups" element={<MyGroups />} />
                <Route path="/member/payments" element={<PaymentMenu />} />
                <Route path="/member/alerts" element={<Alerts />} />
              </>
            )}

            <Route path="*" element={<Navigate to={`/${role}/dashboard`} replace />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </BrowserRouter>
  );
}
